import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const IdCardOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path
        d="M16.69 5.6c2.04 0 3.71 1.66 3.71 3.71v5.26c0 2.04-1.66 3.71-3.71 3.71H7.31c-2.04 0-3.71-1.66-3.71-3.71V9.31c0-2.04 1.66-3.71 3.71-3.71h9.38Zm0-1.6H7.31C4.38 4 2 6.38 2 9.31v5.26c0 2.93 2.38 5.31 5.31 5.31h9.38c2.93 0 5.31-2.38 5.31-5.31V9.31C22 6.38 19.62 4 16.69 4Z"
        fill={color}
      />
      <Path
        d="M7.67 11.45a1.47 1.47 0 1 0 0-2.94 1.47 1.47 0 0 0 0 2.94ZM8.57 11.85H7.01c-1.28 0-2.32 1.05-2.32 2.32v.75c0 .25.2.45.45.45h5.3c.25 0 .45-.2.45-.45v-.75c0-1.28-1.05-2.32-2.32-2.32ZM18.52 9.59h-5.56c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h5.56c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8ZM16.29 12.69h-3.38c-.44 0-.8.36-.8.8 0 .44.36.8.8.8h3.38c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default IdCardOutlined
